import React, { Children } from "react";
import { StyleSheet, View, Text } from "@react-pdf/renderer";
import generalStyle from "../GeneralStyles";

export const Table = ({ headers, children, themeData }) => {
  const tableBlock = StyleSheet.create({
    table: {
      marginTop: 15,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: themeData.tableBorder,
    },
    headerContainer: {
      ...generalStyle.inLineBlocks,
      padding: 9,
    },
    tableCell1: {
      width: "37%",
    },
    tableCellValue: { width: "15%", textAlign: "right" },
    tableCellValueBig: { width: "18%", textAlign: "right" },
    tableHeaderText1: {
      fontSize: 10,
      ...generalStyle.bold,
    },
    tableHeaderText: {
      ...generalStyle.bold,
      fontSize: 10,
    },
    tableRowpair: {
      padding: 9,
      flexDirection: "row",
      backgroundColor: themeData.tableRowsBackgroundColor,
    },
    tableRowOdd: {
      padding: 9,
      flexDirection: "row",
    },
  });

  return (
    <View data-testid="report-table" style={tableBlock.table}>
      {/* TableHeader */}
      {
        <View style={tableBlock.headerContainer}>
          {headers.map((header, index) => (
            <View
              key={`header-${index}`}
              style={
                index === 0
                  ? tableBlock.tableCell1
                  : index === 4
                  ? tableBlock.tableCellValueBig
                  : tableBlock.tableCellValue
              }
            >
              <Text
                style={
                  index === 0
                    ? tableBlock.tableHeaderText1
                    : tableBlock.tableHeaderText
                }
              >
                {header}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* TableContent */}
      {Children.map(children, (child, index) => {
        return (
          <View
            key={`content-${index}`}
            style={
              index % 2 === 0 ? tableBlock.tableRowpair : tableBlock.tableRowOdd
            }
          >
            {Children.map(child.props.children, (subChild, subIndex) => {
              return (
                <View
                  key={`cell-${subIndex}`}
                  style={
                    subIndex === 0
                      ? tableBlock.tableCell1
                      : subIndex === 4
                      ? tableBlock.tableCellValueBig
                      : tableBlock.tableCellValue
                  }
                >
                  <View style={subIndex !== 0 && { textAlign: "right" }}>
                    {subChild}
                  </View>
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );
};
